const COLORS = {
  primary: '#13B9A8',
  primaryDark: '#00796D',
  accent: '#107CBA',
};

export default COLORS;
